module.exports = __webpack_public_path__ + "img/火龙果4.6bf2831b.png";